export default __webpack_public_path__ + "static/folder-d99d4e911dae6c5704925b018c8ea9b4.png";